import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay]);

$(() => {
  const logoSlider = new Swiper('.swiper.-logos', {
    slidesPerView: 'auto',
    spaceBetween: 10,
    centeredSlides: false,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    speed: 3000,
    loop: true,
    loopAdditionalSlides: 10,
    allowTouchMove: false,
    on: {
      init: function () {
        this.el.classList.add('swiper-initialized');
      },
    },
  });

  const quoteSlider = new Swiper('.quote-slider .swiper', {
    slidesPerView: 1,
    spaceBetween: 40,
    navigation: {
      nextEl: '.swiper__buttons-next',
      prevEl: '.swiper__buttons-prev',
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    speed: 3000,
    loop: true,
  });

  const imageSlider = new Swiper('.image-slider .swiper', {
    loop: true,
    initialSlide: 1,
    spaceBetween: 52,
    slidesPerView: 1.52,
    centeredSlides: true,
    breakpoints: {
      320: {
        spaceBetween: 30,
      },
      768: {
        spaceBetween: 52,
      },
    },
  });

  const jobSlider = new Swiper('.job-slider .swiper', {
    spaceBetween: 50,
    slidesPerView: 2,
    pagination: false,
    navigation: {
      nextEl: '.job-slider .swiper .swiper-button-next',
      prevEl: '.job-slider .swiper .swiper-button-prev',
    },
    breakpoints: {
      320: {
        spaceBetween: 26,
        slidesPerView: 1.1,
      },
      768: {
        spaceBetween: 26,
        slidesPerView: 2.1,
      },
      992: {
        spaceBetween: 26,
        slidesPerView: 2.3,
      },
      1200: {
        spaceBetween: 53,
        slidesPerView: 3.1,
      },
    },
  });

  const timelineSwiper = new Swiper('.timeline .swiper', {
    loop: true,
    spaceBetween: 30,
    slidesPerView: 1,
    navigation: {
      nextEl: '.timeline .swiper-button-next',
      prevEl: '.timeline .swiper-button-prev',
    },
  });

  timelineSwiper.on('slideChange', () => {
    const activeIndex = timelineSwiper.realIndex;
    console.log(activeIndex);
    $('.timeline .timeline__nav-bullet').removeClass('active');
    $('.timeline .timeline__nav-bullet').eq(activeIndex).addClass('active');
  });

  $('.timeline .timeline__nav-bullet').on('click', function() {
    var index = $(this).data('slide');

    timelineSwiper.slideTo(index);

    $('.timeline .timeline__nav-bullet').removeClass('active');
    $(this).addClass('active');
  });
});
